export default "/images/calendar.svg?ef76c724aef8d32e0ce4361ca6c0bb43";